import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import Country from "../models/Country";

const getCountries = async () => {
    const countriesRef = collection(db, "country");
    const countriesSnapshot = await getDocs(countriesRef);
    const countries: Country[] = [];
    countriesSnapshot.forEach((doc) => {
        countries.push(doc.data() as Country);
    });
    return countries;
}

const CountryController = {
    getCountries
}

export default CountryController;